const S3 = {
  bucketName: "sahari",
  dirName: "sahari",
  region: "ap-south-1",
  accessKeyId: "qwertyuiopqwertyuiop",
  secretAccessKey: "qwertyuiopqwertyuiopqwertyuiopqwertyuiop",
};
export default S3;
